import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import TabbedContentBlade, { ITabContent } from "@organic-return/foundation-react/src/components/Blades/TabbedContentBlade";
import { WsrvImage } from "@organic-return/foundation-react/src/components/Media";
import { EWsrvTransform } from "@organic-return/foundation-react/src/lib";
import { useSiteContext } from "../common/SiteContext";

export interface IOfficesByCityConfig {
    tabsSortFn: (a: any, b: any) => any;
}

const OfficesByCity = (props: any) => {
    const siteContext = useSiteContext()
    const data = useStaticQuery(graphql`
    query {
        allOffice {
          group(field: {address: {city: SELECT}}) {
            nodes {
              originID
              address {
                street1
                city
              }
              phone
              email
              path
              photos {
                url
              }
            }
            fieldValue
          }
        }
        allDrupalOffice {
          nodes {
            drupal_id
            location
          }
        }
    }
  `)

    const drupalOffices = data?.allDrupalOffice?.nodes ?? []
    if (siteContext.officeByCityModuleConfig?.tabsSortFn) {
        data.allOffice?.group.sort(siteContext.officeByCityModuleConfig.tabsSortFn)
    }

    let tabContent: ITabContent[] = []
    if (data.allOffice?.group && data.allOffice.group.length > 0) {
        tabContent = data.allOffice.group.map((item: any) => {
            let tab: ITabContent = {
                tabTitle: item.fieldValue,
                contentClassName: "w-full",
                content: (
                    <div className="w-full flex flex-row flex-wrap items-stretch">
                        <WsrvImage
                            urlParams={{
                                originURL: item.nodes?.[0].photos?.[0].url,
                                preset: EWsrvTransform.limit
                            }}
                            imgProps={{
                                className: "w-full lg:w-2/3 object-cover"
                            }}
                            lazy={false}
                        />
                        <div className="w-full lg:w-1/3 flex flex-col justify-center inverted">
                            {item.nodes?.map((office: any, index: number) => {
                                const location = drupalOffices.find((o: any) => o.drupal_id == office.originID)?.location
                                return (
                                    <>
                                        {index > 0 && (
                                            <div className="h-px bg-body-text-inverted mx-8"></div>
                                        )}
                                        <div className="w-full py-14 px-10 flex flex-col items-center text-center">
                                            <h3>{office.address?.city}</h3>
                                            {location && <h4>{location}</h4>}
                                            {office.phone && <span className="block mt-2.5">Phone: {office.phone}</span>}
                                            {office.email && <span className="block">{office.email}</span>}
                                            <div className="w-full flex justify-center gap-x-3">
                                                {office.address?.street1 && (
                                                    <a className="text-button-text bg-button-bg border mt-5 py-2 px-4" href={`http://maps.google.com/?q=${office.address.street1} ${office.address?.city}`}>Direction</a>
                                                )}
                                                {office?.path && (
                                                    <a className="text-button-text bg-button-bg border mt-5 py-2 px-4" href={`${office.path}`}>View Listings</a>
                                                )}
                                            </div>
                                        </div>
                                    </>
                                )
                            })}
                        </div>
                    </div>
                )
            }
            return tab
        })
    }

    return (
        <TabbedContentBlade
            className="relative w-full max-w-screen-xl mx-auto px-2 md:px-7 offices-by-city"
            tabListClassName="gap-x-5 lg:gap-x-14"
            tabListItemClassNames={{
                default: "!w-auto md:!w-auto lg:!w-auto",
                active: "!w-auto md:!w-auto lg:!w-auto border-b border-body-bg-inverted"
            }}
            title={props.title}
            tabs={tabContent}
        />
    )
}

export default OfficesByCity

export const query = graphql`
fragment DrupalOfficesByCityContent on DrupalOfficesByCity {
    id
    title 
}
`